//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.FtmFixedCurvesBuilderList.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../GeometricUtilities/GeometricUtilities.FtmTransformCurvesBuilderList.js";
import "../no/ScCollector.js";
import "../GeometricUtilities/GeometricUtilities.FtmTransformPointsBuilderList.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/ObjectList.js";
let d=[[[0,"AsOriginalOption",1,0],[0,"ClassAOption",1,0],[0,"DistanceTolerance",1,0],[1,"FixedCurvesList",0,"GeometricUtilities.FtmFixedCurvesBuilderList",0],[0,"Free2DOption",1,0],[0,"Free2DPlane",1,"Plane",0],[0,"HideOriginal",1,0],[0,"ShowTransformVectors",1,0],[1,"StepExpression",0,"Expression",0],[1,"TransformCurves",0,"Section",0],[1,"TransformCurvesList",0,"GeometricUtilities.FtmTransformCurvesBuilderList",0],[1,"TransformFaces",0,"ScCollector",0],[1,"TransformPointsList",0,"GeometricUtilities.FtmTransformPointsBuilderList",0]],[],[]];
SPLM.Features.FreeTransformerBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.FreeTransformerBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;